import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getAccessBreakdown = api(async function getAccessBreakdown({ clientId }) {
    return query(
        gql`
            query getAccessBreakdown($clientId: String) {
                getAccessBreakdown(clientId: $clientId)
            }
        `,
        { clientId },
        { returns: "getAccessBreakdown" }
    )
})
